import { createContext, useContext, type ReactNode } from "react";

const Context = createContext<string[]>([]);

export const useActiveSalesCampaignCodes = () => useContext(Context);

export const ActiveSalesCampaignCodesProvider = ({ children, value }: { children: ReactNode; value: string[] }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
